var pad = require('./pad');

module.exports = function lpad(str, length, padStr) {
  return pad(str, length, padStr);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/lpad.js
// module id = 822
// module chunks = 0